// extracted by mini-css-extract-plugin
module.exports = {"trigger":"facet-FacetGroupMenuTitle__trigger--2MMRy","isActive":"facet-FacetGroupMenuTitle__isActive--1899W"};